import React from 'react';
import aluna1 from '../assets/images/aluna1.jpeg';
import aluna2 from '../assets/images/aluna2.jpeg';
import aluna3 from '../assets/images/aluna3.jpeg';
import aluna4 from '../assets/images/aluna4.jpeg';
import aluna5 from '../assets/images/aluna5.jpeg';
import cliente1 from '../assets/images/cliente1.jpeg';
import cliente2 from '../assets/images/cliente2.jpeg';
import cliente3 from '../assets/images/cliente3.jpeg';
import cliente4 from '../assets/images/cliente4.jpeg';
import cliente5 from '../assets/images/cliente5.jpeg';

const StudentTransformation = () => {
  const instagramAlunasPosts = [
    aluna1,
    aluna2,
    aluna3,
    aluna4,
    aluna5,
  ];

  const instagramClientesPosts = [
    cliente1,
    cliente2,
    cliente3,
    cliente4,
    cliente5,
  ];

  return (
    <section className="student-transformation">
      <div className="container">
        <div className="transformation-header">
          <h1>Como minhas clientes vivem os resultados no dia a dia:
          (Clientes)</h1>
        </div>
        
        <div className="instagram-posts">
          {instagramClientesPosts.map((img, index) => (
            <div key={index} className="instagram-post">
              <img src={img} alt={`Cliente ${index + 1}`} />
            </div>
          ))}
        </div>

        <div className="transformation-header">
          <h1>E quem aprende comigo também sente a diferença
          (Alunas)</h1>
        </div>
        
        <div className="instagram-posts">
          {instagramAlunasPosts.map((img, index) => (
            <div key={index} className="instagram-post">
              <img src={img} alt={`Aluna ${index + 1}`} />
            </div>
          ))}
        </div>

        
      </div>
    </section>
  );
};

export default StudentTransformation;

